import { OrganizationStatus } from '../../core/constants/status.constants';
import { getStatusLabel } from '../maps/labels/status-labels.map';

export const isOrganizationReadOnlyStatus = (status?: string | null): boolean =>
  status === OrganizationStatus.TO_BE_REVIEWED ||
  status === OrganizationStatus.WAITING_TO_BE_SIGNED;

export const getOrganizationStatusLabel = (status?: string | null): string => {
  return getStatusLabel(status);
};

export const getOrganizationStatusHint = (status?: string | null): string => {
  if (status === OrganizationStatus.DRAFT) {
    return 'Il modulo è in modalità bozza. Completa tutte le sezioni per procedere ulteriormente.';
  }
  if (status === OrganizationStatus.TO_BE_REVIEWED) {
    return "Uno o più moduli sono attualmente in revisione e risultano bloccati in modifica.\n\nAttendi la verifica dell'amministratore prima che possano essere approvati o nuovamente modificati.";
  }
  if (status === OrganizationStatus.WAITING_TO_BE_SIGNED) {
    return "Il modulo è in attesa della firma del manuale. Le modifiche sono temporaneamente bloccate fino all'aggiornamento dello stato.";
  }
  if (status === OrganizationStatus.COMPLETED) {
    return 'Questa versione è completata. Puoi procedere con le modifiche per generare una nuova versione bozza.';
  }

  return '';
};
